import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import { useEffect } from "react";
import UpdateProfile from "./pages/UpdateProfile";
import AuditTrail from "./pages/AuditTrail";
import ResetPassword from "./pages/ResetPassword";
import ClientDetail from "./pages/ClientDetail";
import WardDetail from "./pages/WardDetail";
import UserActivation from "./pages/UserActivation";
import Redirect from "./Redirect";
import ForgotPassword from "./pages/ForgotPassword";
import LoginMfa from "./pages/LoginMfa";
import ChangePassword from "./pages/ChangePassword";
import ManageClient from "./pages/ManageClient";

import PageNotFound from "./pages/PageNotFound";

import ManageWard from "./pages/ManageWard";
import Report from "./pages/Report";
import AuditBedList from "./pages/AuditBedList";
import WorkForce from "./pages/WorkForce";
import Location from "./pages/Location";
import Policy from "./pages/Policy";
import TermsConditions from "./pages/TermsConditions";
import Aup from "./pages/Aup";
import UcrtModule from "./pages/UcrtModule";
import UcrtReportList from "./components/admin/report/UcrtReportList";
import UcrtReport from "./pages/UcrtReport";
import UcrtAuditTrail from "./pages/UcrtAuditTrail";
import ReportTimeSetup from "./pages/ReportTimeSetup";
import ImcModule from "./pages/ImcModule";
import ImcAuditList from "./components/admin/imc/ImcAuditList";

function App() {
  const admin = useSelector((state) => state.admin);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    // const user = localStorage.getItem('user');
    // dispatch(checkUser(user))
    // console.log = () => {}
  }, []);

  const manageRoutes = () => {
    if (!admin?.isAdminLoggedIn) {
      return (
        <>
          <Route path="*" element={<Redirect to="/login" />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/login-mfa" element={<LoginMfa />} />
          <Route exact path="/privacy-notice" element={<Policy />} />
          <Route
            exact
            path="/terms-and-conditions"
            element={<TermsConditions />}
          />
          <Route exact path="/acceptable-use-policy" element={<Aup />} />
          <Route
            exact
            path="/user-activation/:activationKey"
            element={<UserActivation />}
          />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route
            exact
            path="/change-password/:token"
            element={<ChangePassword />}
          />
          <Route exact path="/page-not-found" element={<PageNotFound />} />
        </>
      );
    }
    if (admin?.isAdminLoggedIn) {
      return (
        <>
          <Route path="*" element={<Redirect to="/" />} />
          <Route exact path="/" element={<AdminDashboard />} />
          <Route exact path="/manage-ward" element={<ManageWard />} />
          <Route exact path="/ward-detail/:wardId" element={<WardDetail />} />
          <Route exact path="/manage-client" element={<ManageClient />} />
          <Route exact path="/audit-trail" element={<AuditTrail />} />
          <Route exact path="/report" element={<Report />} />
          {admin?.adminDetail?.isAdmin && (
            <Route exact path="/geography" element={<Location />} />
          )}

          <Route exact path="/workforce" element={<WorkForce />} />
          <Route exact path="/report-time" element={<ReportTimeSetup />} />
          <Route exact path="/ucrt-reports" element={<UcrtReport />} />
          <Route exact path="/ucrt-audit-trail" element={<UcrtAuditTrail />} />
          <Route exact path="/ucrt-module" element={<UcrtModule />} />
          <Route exact path="/imc" element={<ImcModule />} />
          <Route exact path="/imc-audit-trail" element={<ImcAuditList />} />
          <Route
            exact
            path="/audit-trail-bed/:bedId"
            element={<AuditBedList />}
          />

          <Route exact path="/update-profile" element={<UpdateProfile />} />
          <Route exact path="/reset-password" element={<ResetPassword />} />
          <Route
            exact
            path="/client-detail/:clientId"
            element={<ClientDetail />}
          />

          <Route exact path="/page-not-found" element={<PageNotFound />} />
          <Route exact path="/privacy-notice" element={<Policy />} />
          <Route
            exact
            path="/terms-and-conditions"
            element={<TermsConditions />}
          />
          <Route exact path="/acceptable-use-policy" element={<Aup />} />
        </>
      );
    }
  };

  return (
    <BrowserRouter>
      <Routes>{manageRoutes()}</Routes>
    </BrowserRouter>
  );
}

export default App;
